import NetInfo from '@react-native-community/netinfo';
export default class NetworkUtils {
	static async isNetworkAvailable() {
		const response = await NetInfo.fetch();
		console.log('status', response.isConnected, response.isInternetReachable);
		return response.isConnected || response.isInternetReachable;
	}
}
